module.exports = __webpack_public_path__ + "static/media/Advertising.87a2284f.svg";